import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const FIX_METHOD = {
  ECONOMIC_METHOD: 'economic_method',
  COMPANY: 'company',
  ECONOMIC_METHOD_AND_COMPANY: 'economic_method_and_company',
} as const;

export const FIX_METHOD_NAME = 'fix_method';

interface Props {
  name?: string;
}

export const RadioGroupFixMethod: FC<Props> = ({ name = FIX_METHOD_NAME }) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('W jaki sposób szkoda została naprawiona?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'vertical'}>
              <RadioItem
                data-testid={`${name}-radio-group-${FIX_METHOD.ECONOMIC_METHOD}`}
                value={FIX_METHOD.ECONOMIC_METHOD}
                label={i18n.t('Metoda gospodarcza')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${FIX_METHOD.COMPANY}`}
                value={FIX_METHOD.COMPANY}
                label={i18n.t('Z pomocą firmy')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${FIX_METHOD.ECONOMIC_METHOD_AND_COMPANY}`}
                value={FIX_METHOD.ECONOMIC_METHOD_AND_COMPANY}
                label={i18n.t('Metoda gospodarcza i pomoc firmy')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
